<script setup>
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false }
})
</script>

<template>
  <div
    :class="
      cn(
        'tw:flex tw:px-6 tw:pt-4 tw:border-t tw:flex-col-reverse tw:gap-y-2 tw:sm:flex-row tw:sm:justify-end tw:sm:gap-x-2',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
